import DownloadButton from "../../../components/buttons/DownloadButton";
import { displayMessage } from "../../../services/helper";

export default () => {
  const allGridColumns = [
    {
      field: "name",
      width: 250,
      headerName: displayMessage("NAME"),
      valueGetter: (params) => params.row?.name || "",
    },
    {
      field: "description",
      width: 250,
      headerName: displayMessage("DESCRIPTION"),
      valueGetter: (params) => params.row?.description || "",
    },
    {
      field: "videoRepeatCount",
      width: 250,
      headerName: displayMessage("VIDEO_REPEAT_COUNT"),
      renderCell: (params) => params.row?.videoRepeatCount,
    }
  ];
  return allGridColumns;
};
